import { render, staticRenderFns } from "./itemMenu.vue?vue&type=template&id=6b18ea08&scoped=true&"
import script from "./itemMenu.vue?vue&type=script&lang=js&"
export * from "./itemMenu.vue?vue&type=script&lang=js&"
import style0 from "./itemMenu.vue?vue&type=style&index=0&id=6b18ea08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18ea08",
  null
  
)

export default component.exports